import { Table, TableTbodyProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableTbodyProps = TableTbodyProps;

export const createRegistryTableTbody = () => {
	const RegistryTableTbody = forwardRef<HTMLTableSectionElement, RegistryTableTbodyProps>(
		({ className, ...props }, ref) => (
			<Table.Tbody
				ref={ref}
				className={clsx('registry-table-tbody', className)}
				{...props}
			/>
		),
	);

	return RegistryTableTbody;
};
